import styled from 'styled-components';
import { AiOutlineFileAdd } from 'react-icons/ai';

const ContainerBlock = styled.div`
  width: 1221px;
  height: 806px;
  margin: 25px 32px 0 27px;
  padding: 0 0 121px 45px;
  border-radius: 4px;
  border: solid 1px #eaeaea;
  background-color: #fff;
`;

export const Main = styled.div`
  display: grid;
  grid-template-areas:
    'header header header header header header'
    'tableBox tableBox tableBox tableBox tableBox menu'
    'footer footer footer footer footer menu';
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  height: 100px;
`;

export const Header = styled.div`
  grid-area: header;
  width: auto;
  height: ${({ isTaskComponent }) => (isTaskComponent ? '86px' : '180px')};
  margin-top: 15px;
  padding: 0px 33px 0px 14px;
`;

export const TableBox = styled.div`
  grid-area: tableBox;
  min-width: ${({ isTaskComponent }) => (isTaskComponent ? '788px' : '1146px')};
  min-height: 420px;
`;

export const SideBar = styled.div`
  grid-area: menu;
  width: 31px;
  min-height: 382px;
  padding: 0px 15px 15px 0px;
  border: solid 1px #eaeaea;
  background-color: #fff;
  position: relative;

  .iconMenu {
    width: auto;
    height: auto;
  }
  .icon {
    padding: 5px;
  }
  .informationIcon {
    bottom: 14px;
    position: absolute;
    margin-left: 11px;
  }
  .spectrum-Dialog {
    width: 304px;
    height: 256.7px;
    margin: 0 0 38.2px;
    padding: 24.7px 25px 25px 12.4px;
    box-shadow: 0 1px 15px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
  }
`;

export const Title = styled.span`
  width: auto;
  height: 30px;
  margin: 15px 18px 10px 0;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #2c2c2c;
`;

export const Path = styled.h3`
  height: 14px;
  margin: 10px 0px 25.3px 0;
  font-size: 14px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #959595;
`;

export const TempIcon = styled.div`
  width: 15px;
  height: 14px;
  border-radius: 5px;
  border: solid 2px #00000094;
  padding-top: 2px;
  text-align: center;
  font-size: 10px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;
export const AemTempIcon = styled.div`
  width: 15px;
  height: 14px;
  border-radius: 5px;
  border: solid 2px #00000094;
  padding-top: 4px;
  text-align: center;
  font-size: 6px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`;

export const Footer = styled.div`
  grid-area: footer;
  min-width: ${({ isTaskComponent }) => (isTaskComponent ? '778px' : '1146px')};
  height: 46px;
  border: solid 1px #eaeaea;
  background-color: #fff;
  display: inline-flex;

  .footerIcon {
    height: 20px;
    padding: 1%;
  }
  .footerIconRight {
    margin-left: auto;
    padding: 1%;
  }
`;

export const NameText = styled.span`
  margin-left: 10px;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`;

export const CellText = styled.span`
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000;
`;

export const Label = styled.div`
  width: 149px;
  height: 15px;
  margin: 0 4px 10px 20px;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #8e8e8e;
`;

export const FinalMessage = styled.h1`
  margin-left: 330px;
  width: 100%;
`;

export const OutlineAddFile = styled(AiOutlineFileAdd)`
  padding: 5px;
`;

export default ContainerBlock;
